/* ============================================================
   GYAANSTORE - HOVER QUICK-ADD MODULE
   File: assets/gs-quick-add.js  �  load ONCE in theme.liquid (defer)

   Adds the hovered card's variant to the cart via /cart/add.js,
   then refreshes Dawn's cart drawer/notification and fires
   cart:updated. Replaces the per-card inline copy.

   Markup hook: <button ... onclick="return window.gsHoverQuickAdd(this, event)">
   ============================================================ */
if (typeof window.gsHoverQuickAdd === 'undefined') {
  window.gsHoverQuickAdd = function (btn, event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    }
    if (!btn || btn.disabled || btn.classList.contains('is-loading')) return false;

    var variantId = btn.getAttribute('data-variant-id');
    var label = btn.querySelector('.gs-card-hover-atc__label');
    var oldText = label ? label.textContent : 'QUICK ADD';

    if (!variantId) {
      if (label) label.textContent = 'ERROR';
      setTimeout(function () { if (label) label.textContent = oldText || 'QUICK ADD'; }, 1400);
      return false;
    }

    function getDawnCartElement() {
      return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    }
    function getDawnSectionsToRender(cartEl) {
      if (!cartEl) return [];
      try {
        if (typeof cartEl.getSectionsToRender === 'function') {
          return cartEl.getSectionsToRender().map(function (s) { return s.id; });
        }
      } catch (e) {}
      return ['cart-icon-bubble', 'cart-live-region-text'];
    }
    function finishButton(successText) {
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
      if (!btn.hasAttribute('data-sold-out')) btn.disabled = false;
      if (label) {
        label.textContent = successText || 'QUICK ADD';
        setTimeout(function () {
          if (!btn.classList.contains('is-loading')) label.textContent = oldText || 'QUICK ADD';
        }, 1800);
      }
    }

    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    if (label) label.textContent = 'ADDING...';

    var cartEl = getDawnCartElement();
    var sections = getDawnSectionsToRender(cartEl);
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    if (sections.length) {
      formData.append('sections', sections.join(','));
      formData.append('sections_url', window.location.pathname);
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
      credentials: 'same-origin'
    })
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response.status && response.status !== 200) throw response;
        if (cartEl && typeof cartEl.renderContents === 'function') {
          try { cartEl.renderContents(response); } catch (e) { console.warn('Cart render failed:', e); }
        }
        /* open the drawer so it feels native */
        if (cartEl && cartEl.classList && cartEl.classList.contains('is-empty')) {
          cartEl.classList.remove('is-empty');
        }
        if (cartEl && typeof cartEl.open === 'function') {
          try { cartEl.open(); } catch (e) {}
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'product-card-quick-add' } }));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        finishButton('ADDED');
      })
      .catch(function (error) {
        console.error('Product card quick add error:', error);
        if (label) label.textContent = 'ERROR';
        setTimeout(function () { finishButton(oldText || 'QUICK ADD'); }, 1400);
      });

    return false;
  };
}
